import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28a84080"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  id: "com_form_contet1"
}
const _hoisted_3 = { class: "errorform" }
const _hoisted_4 = {
  key: 0,
  class: "error-message"
}
const _hoisted_5 = {
  key: 2,
  id: "contents1"
}
const _hoisted_6 = {
  key: 0,
  class: "application-error error-message"
}
const _hoisted_7 = {
  key: 3,
  id: "contents1"
}
const _hoisted_8 = { class: "com_sec1" }
const _hoisted_9 = { class: "com_inner1 clearfix" }
const _hoisted_10 = { class: "com_utl1" }
const _hoisted_11 = { class: "com_date1 roboto" }
const _hoisted_12 = { class: "com_category1" }
const _hoisted_13 = {
  key: 0,
  class: "com_new1 roboto"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text__item" }, "参照新規"),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text__item",
    "aria-hidden": "true"
  }, "参照新規")
], -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text__item" }, "修正"),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text__item",
    "aria-hidden": "true"
  }, "修正")
], -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 1,
  class: "error-message"
}
const _hoisted_20 = { class: "com_d_title1" }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = ["src", "alt"]
const _hoisted_23 = { key: 3 }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = {
  key: 4,
  class: "com_links1"
}
const _hoisted_26 = {
  key: 0,
  class: "item1"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", null, "リンク")
], -1))
const _hoisted_28 = ["href", "onClick"]
const _hoisted_29 = ["href", "onClick"]
const _hoisted_30 = {
  key: 1,
  class: "item1"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "文書ファイル", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "全データダウンロード", -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 0,
  class: "sub1"
}
const _hoisted_36 = ["onClick"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ダウンロード", -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = {
  key: 5,
  class: "img-container"
}
const _hoisted_40 = ["src", "alt"]
const _hoisted_41 = {
  key: 6,
  class: "sticky-banner"
}
const _hoisted_42 = { key: 7 }
const _hoisted_43 = {
  key: 8,
  class: "applyend-message"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text__item" }, "戻る"),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text__item",
    "aria-hidden": "true"
  }, "戻る")
], -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_BreadcrumbsComponent = _resolveComponent("BreadcrumbsComponent")!
  const _component_VideoPlayer = _resolveComponent("VideoPlayer")!
  const _component_EventApplicationModal = _resolveComponent("EventApplicationModal")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!
  const _component_BackToTop = _resolveComponent("BackToTop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isPreview)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_HeaderComponent)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isInitError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.apiErrorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.apiErrorMessage), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isDataFetched)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_ctx.apiErrorMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.apiErrorMessage), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isCategoryIdFetched)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("section", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (_ctx.isCategoryIdFetched && !_ctx.isPreview)
                ? (_openBlock(), _createBlock(_component_BreadcrumbsComponent, {
                    key: 0,
                    title: _ctx.contentsData.title,
                    categoryId: _ctx.contentsData.categoryId
                  }, null, 8, ["title", "categoryId"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.contentsData.eventDate), 1),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.contentsData.subCategoryName), 1),
                  (_ctx.contentsData.newFlg)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, "NEW"))
                    : _createCommentVNode("", true)
                ]),
                (!_ctx.isPreview)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      (_ctx.isKaunetAdmin)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: "#",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (
                _ctx.copyContents(_ctx.contentsData.categoryId, _ctx.contentsData.contentsId)
              ), ["prevent"])),
                            class: "com_s_button1"
                          }, _hoisted_16))
                        : _createCommentVNode("", true),
                      (_ctx.isKaunetAdmin)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: "#",
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (
                _ctx.editContents(_ctx.contentsData.categoryId, _ctx.contentsData.contentsId)
              ), ["prevent"])),
                            class: "com_s_button2"
                          }, _hoisted_18))
                        : _createCommentVNode("", true),
                      (_ctx.contentsData.isFavorite)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 2,
                            class: "com_favorite1 selected",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleToggleFavorite(_ctx.contentsData)))
                          }))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 3,
                            class: "com_favorite1",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleToggleFavorite(_ctx.contentsData)))
                          }))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.errorMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.errorMessage), 1))
                : _createCommentVNode("", true),
              _createElementVNode("h1", _hoisted_20, _toDisplayString(_ctx.contentsData.title), 1),
              (_ctx.contentsData.contentsImgList.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentsData.contentsImgList, (imgFile) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: imgFile.rowNo,
                        class: "img-container"
                      }, [
                        (imgFile.rowNo == 1)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: `/${imgFile.imgPath}/${imgFile.imgName}`,
                              alt: imgFile.imgName
                            }, null, 8, _hoisted_22))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.contentsData.contentsVideoList.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.contentsData.contentsVideoList[0].videoExp), 1),
                    _createElementVNode("div", {
                      class: _normalizeClass(_ctx.containerClass)
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentsData.contentsVideoList, (videoData, index) => {
                        return (_openBlock(), _createBlock(_component_VideoPlayer, {
                          key: videoData.rowNo,
                          videoSrc: `/${videoData.videoPath}/${videoData.videoName}`,
                          contentsId: _ctx.contentsData.contentsId,
                          screenName: "イベント申し込み画面",
                          class: _normalizeClass(_ctx.playerClass(index)),
                          onHalfWatched: _ctx.handleHalfWatched
                        }, null, 8, ["videoSrc", "contentsId", "class", "onHalfWatched"]))
                      }), 128))
                    ], 2)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "ql-editor",
                innerHTML: _ctx.sanitizedContent
              }, null, 8, _hoisted_24),
              (_ctx.isExistsLinkAreaItem)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    (_ctx.contentsData.contentsLinkList.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _hoisted_27,
                          _createElementVNode("div", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentsData.contentsLinkList, (link) => {
                              return (_openBlock(), _createElementBlock("ul", {
                                key: link.rowNo,
                                class: "list1"
                              }, [
                                _createElementVNode("li", null, [
                                  (_ctx.isInternalLink(link.url))
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        href: `${link.url}`,
                                        class: "com_link1",
                                        onClick: ($event: any) => (_ctx.regLinkClick(link.url))
                                      }, _toDisplayString(link.caption || link.url), 9, _hoisted_28))
                                    : (_openBlock(), _createElementBlock("a", {
                                        key: 1,
                                        href: `${link.url}`,
                                        class: "com_link1",
                                        target: "_blank",
                                        onClick: ($event: any) => (_ctx.regLinkClick(link.url))
                                      }, _toDisplayString(link.caption || link.url), 9, _hoisted_29))
                                ])
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.contentsData.contentsTempFileList.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _createElementVNode("div", null, [
                            _hoisted_31,
                            _createElementVNode("a", {
                              href: "#",
                              class: "com_dl_button1",
                              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (
                  _ctx.downloadFiles(
                    _ctx.contentsData.categoryId,
                    _ctx.contentsData.contentsId,
                    ''
                  )
                ), ["prevent"]))
                            }, _hoisted_33)
                          ]),
                          _createElementVNode("div", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentsData.contentsTempFileList, (tmpFile) => {
                              return (_openBlock(), _createElementBlock("ul", {
                                key: tmpFile.rowNo,
                                class: "list2"
                              }, [
                                _createElementVNode("li", null, [
                                  _createElementVNode("a", {
                                    href: "#",
                                    class: "com_link1",
                                    target: "_blank",
                                    onClick: _withModifiers(($event: any) => (
                      _ctx.downloadFiles(
                        _ctx.contentsData.categoryId,
                        _ctx.contentsData.contentsId,
                        tmpFile.tempFileName
                      )
                    ), ["prevent"])
                                  }, _toDisplayString(tmpFile.tempFileName), 9, _hoisted_34),
                                  (tmpFile.tempFileSize)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_35, " (" + _toDisplayString(tmpFile.tempFileSize) + ")", 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("a", {
                                    href: "#",
                                    class: "com_dl_button2",
                                    onClick: _withModifiers(($event: any) => (
                      _ctx.downloadFiles(
                        _ctx.contentsData.categoryId,
                        _ctx.contentsData.contentsId,
                        tmpFile.tempFileName
                      )
                    ), ["prevent"])
                                  }, _hoisted_38, 8, _hoisted_36)
                                ])
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.contentsData.contentsImgList.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentsData.contentsImgList.slice(1), (imgFile) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: imgFile.rowNo
                      }, [
                        _createElementVNode("img", {
                          src: `/${imgFile.imgPath}/${imgFile.imgName}`,
                          alt: imgFile.imgName
                        }, null, 8, _hoisted_40)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (
            !_ctx.contentsData.isRegistrationEnded && !_ctx.contentsData.isApplication
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    _createElementVNode("button", {
                      type: "button",
                      name: "btnApply",
                      class: "button1",
                      onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onApply && _ctx.onApply(...args)), ["prevent"]))
                    }, " 申し込む ")
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.contentsData.isRegistrationEnded && _ctx.contentsData.isApplication)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                    _createElementVNode("button", {
                      type: "button",
                      name: "btnCancelApp",
                      class: "button2",
                      onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)), ["prevent"]))
                    }, " 申し込みキャンセル ")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.contentsData.isRegistrationEnded)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, " お申し込み受付を終了いたしました。 "))
                : _createCommentVNode("", true),
              (!_ctx.isPreview)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 9,
                    href: "#",
                    class: "com_b_button1",
                    onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goback && _ctx.goback(...args)), ["prevent"]))
                  }, _hoisted_45))
                : _createCommentVNode("", true),
              _createVNode(_component_EventApplicationModal, {
                isOpen: _ctx.isOpenMessageModal,
                title: _ctx.modalTitle,
                message: _ctx.modalMessage,
                addMessage: _ctx.modalAddMessage,
                onCloseModal: _ctx.handlePreviewModalClosed
              }, null, 8, ["isOpen", "title", "message", "addMessage", "onCloseModal"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isPreview)
      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
          _createVNode(_component_FooterComponent)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isPreview)
      ? (_openBlock(), _createBlock(_component_BackToTop, { key: 5 }))
      : _createCommentVNode("", true)
  ], 64))
}